var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VContainer',[_c('VRow',{attrs:{"justify":"center"}},[_c('VCol',{attrs:{"cols":"12","md":"8"}},[_c('VCard',{staticClass:"pa-3 pa-md-7 px-md-12 mb-5",attrs:{"elevation":"1"}},[_c(_vm.localizedComponent,{tag:"Component"})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }